import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { SidebarCircle, SidebarPeersState } from './types';

const initialState: SidebarPeersState = {
  circles: [],
  isLoading: false,
  error: null
};

export const slice = createSlice({
  name: 'sidebarPeers',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    loadSuccess(state, action: PayloadAction<{ circles: SidebarCircle[] }>) {
      state.isLoading = false;
      state.circles = action.payload.circles;
    },
    hasError(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    }
  }
});

export default slice.reducer;
